
// featured product slider starts here

document.addEventListener("DOMContentLoaded", function () {
  var sliderSelector = '.slick-slider-initialiser';
  var $slider = jQuery(sliderSelector);
  if (!$slider.length) {
    return;
  }
  // Function to try initializing slick
  function tryInitSlick(attempt = 1) {
    var slideCount = $slider.children().length;
    // If slides still not loaded, wait and retry
    if (slideCount <= 5) {
      if (attempt < 30) {   // retry max 20 times (2 seconds)
        setTimeout(() => tryInitSlick(attempt + 1), 200);
      } else {
        console.log("Giving up — slides never exceeded 5");
      }
      return;
    }
    // Desktop only
    if (window.innerWidth < 768) {
      return;
    }
    $slider.slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      infinite: false,
      arrows: true,
      dots: false,

      prevArrow: `
        <button type="button" class="slick-prev-custom slick-arrow">
          <svg class="flickity-button-icon" viewBox="0 0 100 100">
            <path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z"
              class="arrow"></path>
          </svg>
        </button>
      `,

      nextArrow: `
        <button type="button" class="slick-next-custom slick-arrow">
          <svg class="flickity-button-icon" viewBox="0 0 100 100">
            <path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z"
              class="arrow" transform="translate(100, 100) rotate(180)"></path>
          </svg>
        </button>
      `
    });
  }

  // Start retry logic
  tryInitSlick();
});

// featured product slider ends here


// recommended product slider starts here

const recommendedSelector = '.recommended-slider';

(function () {
  function initSlickFor($slider, label = 'recommended') {
    if (!$slider || !$slider.length) {
      return;
    }
    if ($slider.hasClass('slick-initialized')) {
      return;
    }
    const slideCount = $slider.children().length;
    if (slideCount <= 5) {
      return;
    }
    if (window.innerWidth < 768) {
      return;
    }
    $slider.slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      infinite: false,
      arrows: true,
      dots: false,
      prevArrow: `
        <button type="button" class="slick-prev-custom slick-arrow">
          <svg class="flickity-button-icon" viewBox="0 0 100 100">
            <path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z" class="arrow"></path>
          </svg>
        </button>
      `,
      nextArrow: `
        <button type="button" class="slick-next-custom slick-arrow">
          <svg class="flickity-button-icon" viewBox="0 0 100 100">
            <path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z"
              class="arrow" transform="translate(100, 100) rotate(180)"></path>
          </svg>
        </button>
      `
    });
  }
  function tryInitOnce(sliderEl, label = 'recommended') {
    const $slider = jQuery(sliderEl);
    initSlickFor($slider, label);
  }
  function watchAndInit(sliderEl, label = 'recommended') {
    const $slider = jQuery(sliderEl);
    if (!$slider.length) {
      return;
    }
    if ($slider.hasClass('slick-initialized')) {
      return;
    }
    const observer = new MutationObserver((mutations) => {
      if ($slider.hasClass('slick-initialized')) {
        observer.disconnect();
        return;
      }
      const childCount = $slider.children().length;
      if (childCount > 5) {
        initSlickFor($slider, label);
        if ($slider.hasClass('slick-initialized')) {
          observer.disconnect();
        }
      }
    });
    observer.observe(sliderEl, { childList: true, subtree: true });
    tryInitOnce(sliderEl, label);
  }
  function onRecommendationsLoaded(evt) {
    try {
      let section = null;
      if (evt && evt.detail && evt.detail.section) {
        if (typeof evt.detail.section === 'string') {
          section = document.getElementById(evt.detail.section) || document.querySelector(`#${evt.detail.section}`);
        } else if (evt.detail.section instanceof Element) {
          section = evt.detail.section;
        }
      }
      if (section) {
        const found = section.querySelector(recommendedSelector);
        if (found) {
          watchAndInit(found, 'recommended');
          return;
        } else {
          console.log('[recommended] No slider inside event section, will try global selector');
        }
      }
      const matches = document.querySelectorAll(recommendedSelector);
      if (!matches.length) {
        return;
      }
      matches.forEach((el, i) => {
        watchAndInit(el, `recommended#${i + 1}`);
      });
    } catch (err) {
      console.error('[recommended] error in recommendations:loaded handler', err);
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('recommendations:loaded', onRecommendationsLoaded);
    const preExisting = document.querySelectorAll(recommendedSelector);
    if (preExisting.length) {
      preExisting.forEach((el, i) => watchAndInit(el, `recommended-pre#${i + 1}`));
    } else {
      console.log('[recommended] No pre-existing recommended slider found — waiting for event or late DOM changes');
    }
  });
})();
// recommended product slider ends here